module.exports = __webpack_public_path__ + "static/media/landing_second.a5df9b30.png";